module.exports = __webpack_public_path__ + "static/img/cont2702.c006bb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont2702.jpg
// module id = 48Qz
// module chunks = 0